export var ValidationTypes;

(function (ValidationTypes) {
  ValidationTypes[ValidationTypes["Error"] = 0] = "Error";
  ValidationTypes[ValidationTypes["Success"] = 1] = "Success";
  ValidationTypes[ValidationTypes["Default"] = 2] = "Default";
})(ValidationTypes || (ValidationTypes = {}));